'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3, _dec3, _class4, _dec4, _class5, _dec5, _class6, _dec6, _class7, _dec7, _class8, _dec8, _class9, _class10, _temp2, _dec9, _class11, _class12, _temp3, _dec10, _class13, _class14, _temp4, _dec11, _class15, _class16, _temp5;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactChartjs = require('react-chartjs');

var _reactSlidedown = require('react-slidedown');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _PlanScorecardInvestmentOptions = require('./PlanScorecardInvestmentOptions.css');

var _PlanScorecardInvestmentOptions2 = _interopRequireDefault(_PlanScorecardInvestmentOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FundRowFullHeader = (_dec = (0, _reactCssModules2.default)(_PlanScorecardInvestmentOptions2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FundRowFullHeader, _Component);

  function FundRowFullHeader() {
    (0, _classCallCheck3.default)(this, FundRowFullHeader);
    return (0, _possibleConstructorReturn3.default)(this, (FundRowFullHeader.__proto__ || (0, _getPrototypeOf2.default)(FundRowFullHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(FundRowFullHeader, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        { styleName: 'dtls-tbl-row' },
        _react2.default.createElement(
          'th',
          { styleName: 'dtls-tbl-lbl c' },
          'Plan option'
        ),
        _react2.default.createElement(
          'th',
          { styleName: 'dtls-tbl-val c' },
          'Rated as*'
        ),
        _react2.default.createElement(
          'th',
          { styleName: 'dtls-tbl-val c' },
          'Sustainable investment'
        ),
        _react2.default.createElement(
          'th',
          { styleName: 'dtls-tbl-val c' },
          'Fossil fuels'
        ),
        _react2.default.createElement(
          'th',
          { styleName: 'dtls-tbl-val c' },
          'Deforestation'
        ),
        _react2.default.createElement(
          'th',
          { styleName: 'dtls-tbl-val c' },
          'Gender equality'
        ),
        _react2.default.createElement(
          'th',
          { styleName: 'dtls-tbl-val c' },
          'Civilian firearms'
        ),
        _react2.default.createElement(
          'th',
          { styleName: 'dtls-tbl-val c' },
          'Prison industrial complex'
        ),
        _react2.default.createElement(
          'th',
          { styleName: 'dtls-tbl-val c' },
          'Military weapons'
        ),
        _react2.default.createElement(
          'th',
          { styleName: 'dtls-tbl-val c' },
          'Tobacco'
        ),
        this.props.noAssets ? null : _react2.default.createElement(
          'th',
          { styleName: 'dtls-tbl-val c' },
          'Plan assets'
        )
      );
    }
  }]);
  return FundRowFullHeader;
}(_react.Component), _class2.propTypes = {
  noAssets: _react.PropTypes.bool
}, _temp)) || _class);
var ClosedNotRated = (_dec2 = (0, _reactCssModules2.default)(_PlanScorecardInvestmentOptions2.default, { allowMultiple: true }), _dec2(_class3 = function (_Component2) {
  (0, _inherits3.default)(ClosedNotRated, _Component2);

  function ClosedNotRated() {
    (0, _classCallCheck3.default)(this, ClosedNotRated);
    return (0, _possibleConstructorReturn3.default)(this, (ClosedNotRated.__proto__ || (0, _getPrototypeOf2.default)(ClosedNotRated)).apply(this, arguments));
  }

  (0, _createClass3.default)(ClosedNotRated, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          styleName: 'grade-0',
          'data-multiline': true,
          'data-effect': 'solid',
          'data-html': true,
          'data-for': 'grade-0-tooltip',
          'data-place': 'bottom',
          'data-tip': '<div style=\'max-width:200px;\'>This fund has been closed to new investors. Existing investors continue to own the fund, but we no longer have access to the holdings, so we don\'t have ratings for this investment option. </div>'
        },
        '-',
        _react2.default.createElement(_reactTooltip2.default, { id: 'grade-0-tooltip' })
      );
    }
  }]);
  return ClosedNotRated;
}(_react.Component)) || _class3);
var NoMatchNotRated = (_dec3 = (0, _reactCssModules2.default)(_PlanScorecardInvestmentOptions2.default, { allowMultiple: true }), _dec3(_class4 = function (_Component3) {
  (0, _inherits3.default)(NoMatchNotRated, _Component3);

  function NoMatchNotRated() {
    (0, _classCallCheck3.default)(this, NoMatchNotRated);
    return (0, _possibleConstructorReturn3.default)(this, (NoMatchNotRated.__proto__ || (0, _getPrototypeOf2.default)(NoMatchNotRated)).apply(this, arguments));
  }

  (0, _createClass3.default)(NoMatchNotRated, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          styleName: 'grade-0',
          'data-multiline': true,
          'data-effect': 'solid',
          'data-html': true,
          'data-for': 'grade-0-tooltip',
          'data-place': 'bottom',
          'data-tip': '<div style=\'max-width:200px;\'>Retirement plans often invest in ' + 'opaque funds called "collective trusts". To get around ' + 'this, we identify mutual funds that are suitable replacements ' + 'to use for our ratings. But sometimes, we aren\'t able to find ' + 'a suitable mutual fund. In that case, we don\'t have ratings ' + 'for that investment option.</div>'
        },
        '-',
        _react2.default.createElement(_reactTooltip2.default, { id: 'grade-0-tooltip' })
      );
    }
  }]);
  return NoMatchNotRated;
}(_react.Component)) || _class4);
var TSPLFundRated = (_dec4 = (0, _reactCssModules2.default)(_PlanScorecardInvestmentOptions2.default, { allowMultiple: true }), _dec4(_class5 = function (_Component4) {
  (0, _inherits3.default)(TSPLFundRated, _Component4);

  function TSPLFundRated() {
    (0, _classCallCheck3.default)(this, TSPLFundRated);
    return (0, _possibleConstructorReturn3.default)(this, (TSPLFundRated.__proto__ || (0, _getPrototypeOf2.default)(TSPLFundRated)).apply(this, arguments));
  }

  (0, _createClass3.default)(TSPLFundRated, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          styleName: 'grade-0',
          'data-multiline': true,
          'data-effect': 'solid',
          'data-html': true,
          'data-for': 'grade-0-tooltip',
          'data-place': 'bottom',
          'data-tip': '<div style=\'max-width:200px;\'>\n            The target date L Funds are composed of different mixes of the\n            individual C, S, I, F, and G funds.\n            To analyze the TSP L Funds, we mapped the underlying individual\n            funds to matching index funds,\n            then modeled the different allocation mixes of each L fund\n            portfolio.\n          </div>'
        },
        '-',
        _react2.default.createElement(_reactTooltip2.default, { id: 'grade-0-tooltip' })
      );
    }
  }]);
  return TSPLFundRated;
}(_react.Component)) || _class5);
var TSPIndFundRated = (_dec5 = (0, _reactCssModules2.default)(_PlanScorecardInvestmentOptions2.default, { allowMultiple: true }), _dec5(_class6 = function (_Component5) {
  (0, _inherits3.default)(TSPIndFundRated, _Component5);

  function TSPIndFundRated() {
    (0, _classCallCheck3.default)(this, TSPIndFundRated);
    return (0, _possibleConstructorReturn3.default)(this, (TSPIndFundRated.__proto__ || (0, _getPrototypeOf2.default)(TSPIndFundRated)).apply(this, arguments));
  }

  (0, _createClass3.default)(TSPIndFundRated, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          styleName: 'grade-0',
          'data-multiline': true,
          'data-effect': 'solid',
          'data-html': true,
          'data-for': 'grade-0-tooltip',
          'data-place': 'bottom',
          'data-tip': '<div style=\'max-width:200px;\'>\n            The Thrift Savings Plan\n            individual C, S, I, F, and G funds\n            do not publish full\n            portfolio holdings, but they track indexes that\n            are shared with other mutual funds.\n            To analyze these funds, we mapped them to matching index funds.\n          </div>'
        },
        '-',
        _react2.default.createElement(_reactTooltip2.default, { id: 'grade-0-tooltip' })
      );
    }
  }]);
  return TSPIndFundRated;
}(_react.Component)) || _class6);
var LowEquityNotRated = (_dec6 = (0, _reactCssModules2.default)(_PlanScorecardInvestmentOptions2.default, { allowMultiple: true }), _dec6(_class7 = function (_Component6) {
  (0, _inherits3.default)(LowEquityNotRated, _Component6);

  function LowEquityNotRated() {
    (0, _classCallCheck3.default)(this, LowEquityNotRated);
    return (0, _possibleConstructorReturn3.default)(this, (LowEquityNotRated.__proto__ || (0, _getPrototypeOf2.default)(LowEquityNotRated)).apply(this, arguments));
  }

  (0, _createClass3.default)(LowEquityNotRated, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          styleName: 'grade-0',
          'data-multiline': true,
          'data-effect': 'solid',
          'data-html': true,
          'data-for': 'grade-0-tooltip',
          'data-place': 'bottom',
          'data-tip': '<div style=\'max-width:200px;\'>We only rate funds that are at ' + 'least 50% invested in equities. This fund did not reach that ' + 'threshold.</div>'
        },
        '-',
        _react2.default.createElement(_reactTooltip2.default, { id: 'grade-0-tooltip' })
      );
    }
  }]);
  return LowEquityNotRated;
}(_react.Component)) || _class7);
var TableDisclaimerFull = (_dec7 = (0, _reactCssModules2.default)(_PlanScorecardInvestmentOptions2.default, { allowMultiple: true }), _dec7(_class8 = function (_Component7) {
  (0, _inherits3.default)(TableDisclaimerFull, _Component7);

  function TableDisclaimerFull() {
    (0, _classCallCheck3.default)(this, TableDisclaimerFull);
    return (0, _possibleConstructorReturn3.default)(this, (TableDisclaimerFull.__proto__ || (0, _getPrototypeOf2.default)(TableDisclaimerFull)).apply(this, arguments));
  }

  (0, _createClass3.default)(TableDisclaimerFull, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'table-disclaimer-full' },
        '* Where possible, we rate the exact investment option offered by the retirement plan. But often, retirement plans use opaque funds called "collective trusts" that don\'t publish their holdings. Usually, these opaque funds are also offered as mutual funds by the same asset manager, with the full holdings published on the SEC\'s website. Whenever a plan offers collective trusts, we identify mutual funds that are suitable replacements to use for our ratings. The funds used for these ratings are noted in the "Rated as" column. ',
        _react2.default.createElement(
          _components.Link,
          {
            to: _config2.default.routes.methodology,
            title: 'Methodology',
            xstrong: true
          },
          'Read our full methodology',
          _react2.default.createElement(_components.LinkIcon, null)
        )
      );
    }
  }]);
  return TableDisclaimerFull;
}(_react.Component)) || _class8);
var FundRowHeader = (_dec8 = (0, _reactCssModules2.default)(_PlanScorecardInvestmentOptions2.default, { allowMultiple: true }), _dec8(_class9 = (_temp2 = _class10 = function (_Component8) {
  (0, _inherits3.default)(FundRowHeader, _Component8);

  function FundRowHeader() {
    (0, _classCallCheck3.default)(this, FundRowHeader);
    return (0, _possibleConstructorReturn3.default)(this, (FundRowHeader.__proto__ || (0, _getPrototypeOf2.default)(FundRowHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(FundRowHeader, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactFlexboxGrid.Row,
        { styleName: 'dtls-tbl-row' },
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 8, styleName: 'dtls-tbl-lbl c' },
          _react2.default.createElement(
            'b',
            null,
            'Plan option'
          )
        ),
        this.props.noAssets ? null : _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 4, styleName: 'dtls-tbl-val c' },
          _react2.default.createElement(
            'b',
            null,
            'Plan assets'
          )
        )
      );
    }
  }]);
  return FundRowHeader;
}(_react.Component), _class10.propTypes = {
  noAssets: _react.PropTypes.bool
}, _temp2)) || _class9);
var FundRowSlim = (_dec9 = (0, _reactCssModules2.default)(_PlanScorecardInvestmentOptions2.default, { allowMultiple: true }), _dec9(_class11 = (_temp3 = _class12 = function (_Component9) {
  (0, _inherits3.default)(FundRowSlim, _Component9);

  function FundRowSlim(props) {
    (0, _classCallCheck3.default)(this, FundRowSlim);

    var _this9 = (0, _possibleConstructorReturn3.default)(this, (FundRowSlim.__proto__ || (0, _getPrototypeOf2.default)(FundRowSlim)).call(this, props));

    _this9.state = {
      investmentOption: props.investmentOption
    };
    return _this9;
  }

  (0, _createClass3.default)(FundRowSlim, [{
    key: 'render',
    value: function render() {
      var investmentOption = this.state.investmentOption;

      var rowStyle = investmentOption.length > 3 ? 'strong' : '';
      var moneyFormatted = _format2.default.money(investmentOption.assets, true, 'US Dollar', false, 1);
      return _react2.default.createElement(
        _reactFlexboxGrid.Row,
        { styleName: 'dtls-tbl-row ' + rowStyle },
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 8, styleName: 'dtls-tbl-lbl' },
          _react2.default.createElement(
            'span',
            null,
            investmentOption.label
          )
        ),
        moneyFormatted === '$0' ? null : _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 4, styleName: 'dtls-tbl-val r' },
          _react2.default.createElement(
            'span',
            null,
            moneyFormatted
          )
        )
      );
    }
  }]);
  return FundRowSlim;
}(_react.Component), _class12.propTypes = {
  investmentOption: _react.PropTypes.object.isRequired
}, _temp3)) || _class11);
var FundRowFull = (_dec10 = (0, _reactCssModules2.default)(_PlanScorecardInvestmentOptions2.default, { allowMultiple: true }), _dec10(_class13 = (_temp4 = _class14 = function (_Component10) {
  (0, _inherits3.default)(FundRowFull, _Component10);

  function FundRowFull(props) {
    (0, _classCallCheck3.default)(this, FundRowFull);

    var _this10 = (0, _possibleConstructorReturn3.default)(this, (FundRowFull.__proto__ || (0, _getPrototypeOf2.default)(FundRowFull)).call(this, props));

    _this10.state = {
      investmentOption: props.investmentOption
    };
    return _this10;
  }

  (0, _createClass3.default)(FundRowFull, [{
    key: 'gradeIntToChar',
    value: function gradeIntToChar(g) {
      if (g === -1) {
        return 'N/A';
      } else if (g === 0 || g) {
        return {
          0: 'TK',
          1: 'A',
          1.5: 'Engagement',
          2: 'B',
          3: 'C',
          4: 'D',
          5: 'F',
          6: 'F'
        }[g];
      } else {
        return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this11 = this;

      var investmentOption = this.state.investmentOption;


      investmentOption.grade_fossil = investmentOption.grade_fossil || 0;
      investmentOption.grade_deforestation = investmentOption.grade_deforestation || 0;
      investmentOption.grade_gender_equality = investmentOption.grade_gender_equality || 0;
      investmentOption.grade_guns = investmentOption.grade_guns || 0;
      investmentOption.grade_prison_industrial_complex = investmentOption.grade_prison_industrial_complex || 0;
      investmentOption.grade_military = investmentOption.grade_military || 0;
      investmentOption.grade_tobacco = investmentOption.grade_tobacco || 0;

      // // make ticker safe for URL
      var sTicker = investmentOption.ticker || 'N';
      var urlBuilder = function urlBuilder(route, profilePath) {
        var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        var url = route + '/' + _format2.default.sanitize(investmentOption.fund_legal_name) + '/' + sTicker + '/' + profilePath + '/' + investmentOption.fund_id + '/' + investmentOption.investment_vehicle_id;
        if (query) {
          url += '?' + query;
        }
        return url;
      };

      var fffUrl = urlBuilder(_config2.default.links.fff + '/fund', 'fossil-fuel-investments');
      var dffUrl = urlBuilder(_config2.default.links.dff + '/fund', 'profile');
      var gefUrl = urlBuilder(_config2.default.links.gef + '/fund', 'gender-lens-score');
      var gffUrl = urlBuilder(_config2.default.links.gff + '/fund', 'gun-investments');
      var pffUrl = urlBuilder(_config2.default.links.pff + '/fund', 'prison-industrial-complex-investments');
      var wffUrl = urlBuilder(_config2.default.links.wff + '/fund', 'weapon-investments');
      var tffUrl = urlBuilder(_config2.default.links.tff + '/fund', 'tobacco-profile');

      var formattedMoney = _format2.default.money(investmentOption.assets, true, 'US Dollar', false, 1);

      // TSP hack
      var isTSP = false;
      if (['FTSP0LINCM', 'FTSP0L2025', 'FTSP0L2030', 'FTSP0L2035', 'FTSP0L2040', 'FTSP0L2045', 'FTSP0L2050', 'FTSP0L2055', 'FTSP0L2060', 'FTSP0L2065', 'FTSP0L2060', 'FTSP0L2065', 'FTSP00000C', 'FTSP00000S', 'FTSP00000I'].includes(investmentOption.fund_id)) {
        isTSP = true;
      }

      //
      return _react2.default.createElement(
        'tr',
        { styleName: 'dtls-tbl-row' },
        _react2.default.createElement(
          'td',
          { styleName: 'dtls-tbl-lbl' },
          _react2.default.createElement(
            'span',
            null,
            investmentOption.label
          )
        ),
        _react2.default.createElement(
          'td',
          { styleName: 'dtls-tbl-val c' },
          investmentOption.ticker ? investmentOption.ticker : investmentOption.label.includes('2015') ? _react2.default.createElement(ClosedNotRated, null) : !isTSP ? _react2.default.createElement(NoMatchNotRated, null) : investmentOption.label.includes('L') ? _react2.default.createElement(TSPLFundRated, null) : _react2.default.createElement(TSPIndFundRated, null)
        ),
        _react2.default.createElement(
          'td',
          { styleName: 'dtls-tbl-val c' },
          // if rated, show a yes/no
          investmentOption.percent_rated_long > 0.5 ? _react2.default.createElement(_components.YesNo, {
            yes: _convert2.default.boolean(investmentOption.sustainable_investment)
          }) : // if not rated, is there a ticker? if ticker, show yes/no
          investmentOption.ticker ? _react2.default.createElement(_components.YesNo, {
            yes: _convert2.default.boolean(investmentOption.sustainable_investment)
          }) : // if no ticker, is there 2015 in name? (i.e. closed)
          investmentOption.label.includes('2015') ? _react2.default.createElement(ClosedNotRated, null) : // if yes, show "closed"
          _react2.default.createElement(NoMatchNotRated, null) // if not, show "no match"

        ),
        [[fffUrl, 'Fossil Free Funds', 'grade_fossil'], [dffUrl, 'Deforestation Free Funds', 'grade_deforestation'], [gefUrl, 'Gender Equality Funds', 'grade_gender_equality'], [gffUrl, 'Gun Free Funds', 'grade_guns'], [pffUrl, 'Prison Free Funds', 'grade_prison_industrial_complex'], [wffUrl, 'Weapon Free Funds', 'grade_military'], [tffUrl, 'Tobacco Free Funds', 'grade_tobacco']].map(function (e, i) {
          var _e = (0, _slicedToArray3.default)(e, 3),
              url = _e[0],
              siteName = _e[1],
              gradeLabel = _e[2];

          return _react2.default.createElement(
            'td',
            { styleName: 'dtls-tbl-val c h3 block' },
            investmentOption.percent_rated_long > 0.5 ? _react2.default.createElement(
              _components.Link,
              {
                to: url,
                title: investmentOption.fund_legal_name + ' - ' + siteName
              },
              _react2.default.createElement(
                'div',
                { styleName: 'grade-' + investmentOption[gradeLabel] },
                _this11.gradeIntToChar(investmentOption[gradeLabel])
              )
            ) : investmentOption.ticker || isTSP ? _react2.default.createElement(LowEquityNotRated, null) : investmentOption.label.includes('2015') ? _react2.default.createElement(ClosedNotRated, null) : _react2.default.createElement(NoMatchNotRated, null)
          );
        }),
        formattedMoney === '$0' ? null : _react2.default.createElement(
          'td',
          { styleName: 'dtls-tbl-val r' },
          _react2.default.createElement(
            'span',
            null,
            _format2.default.money(investmentOption.assets, true, 'US Dollar', false, 1)
          )
        )
      );
    }
  }]);
  return FundRowFull;
}(_react.Component), _class14.propTypes = {
  investmentOption: _react.PropTypes.object.isRequired
}, _temp4)) || _class13);
var PlanScorecardInvestmentOptions = (_dec11 = (0, _reactCssModules2.default)(_PlanScorecardInvestmentOptions2.default, { allowMultiple: true }), _dec11(_class15 = (_temp5 = _class16 = function (_Component11) {
  (0, _inherits3.default)(PlanScorecardInvestmentOptions, _Component11);

  function PlanScorecardInvestmentOptions(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardInvestmentOptions);

    var _this12 = (0, _possibleConstructorReturn3.default)(this, (PlanScorecardInvestmentOptions.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardInvestmentOptions)).call(this, props));

    _this12.state = {
      showInvestmentOptions: false,
      allocationStats: props.allocationStats,
      planOptions: props.planOptions,
      planId: props.planId || null
    };
    return _this12;
  }

  //


  (0, _createClass3.default)(PlanScorecardInvestmentOptions, [{
    key: 'render',
    value: function render() {
      var _this13 = this;

      var _state = this.state,
          planId = _state.planId,
          allocationStats = _state.allocationStats,
          planOptions = _state.planOptions,
          showInvestmentOptions = _state.showInvestmentOptions;

      //

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'button',
          {
            styleName: 'section-slidedown-button',
            onClick: function onClick(e) {
              _this13.setState({
                showInvestmentOptions: !showInvestmentOptions
              });
            }
          },
          _react2.default.createElement(
            'h2',
            { styleName: 'section-slidedown-label' },
            'Plan investment options'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'section-slidedown-icon' },
            _react2.default.createElement(_components.LinkIcon, {
              faclass: showInvestmentOptions ? 'fa-angle-up' : 'fa-angle-down'
            })
          )
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          showInvestmentOptions ? _react2.default.createElement(
            'div',
            { styleName: 'investment-options-wrap' },
            planId && planId === 'thrift-savings-plan' ? _react2.default.createElement(
              'div',
              { styleName: 'tsp-disclaimer' },
              _react2.default.createElement(
                'div',
                { styleName: 'tsp-disclaimer-icon' },
                _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-info-circle' })
              ),
              _react2.default.createElement(
                'p',
                null,
                'Like most retirement plans, The Thrift Savings Plan is composed of target date funds, as well as individual equity and bond funds. But the Thrift Savings Plan is unique in that the target date L Funds are themselves composed of the individual C, S, I, F, and G funds. The "percentage of plan assets" figures below for target dates, equity, bond/fixed income, and other funds have been adjusted to account for this, to avoid double counting. The plan assets for the individual funds have not been adjusted, and represent the total amount invested in those funds, including via the target date L Funds.'
              )
            ) : null,
            _react2.default.createElement(
              'div',
              { styleName: 'plan-option-card' },
              _react2.default.createElement(
                'h3',
                { styleName: 'table-strong' },
                'Target dates'
              ),
              allocationStats.default.percStr === 'NaN%' ? null : _react2.default.createElement(
                'div',
                { styleName: 'doughnut-flex' },
                _react2.default.createElement(_reactChartjs.Doughnut, {
                  data: [{ value: allocationStats.default.perc,
                    // label: 'Other',
                    color: '#313131' }, { value: allocationStats.default.percOther,
                    // label: null,
                    color: '#D5D5D5' }],
                  options: _config2.default.chartOptions,
                  width: '150',
                  height: '150'
                }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'doughnut-flex-text' },
                  _react2.default.createElement(
                    'b',
                    null,
                    allocationStats.default.count
                  ),
                  ' plan ',
                  _format2.default.maybePluralize(allocationStats.default.count, 'option'),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'b',
                    null,
                    allocationStats.default.percStr
                  ),
                  ' of plan assets'
                )
              ),
              _react2.default.createElement(
                'table',
                { styleName: 'full-row-table' },
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(FundRowFullHeader, { noAssets: allocationStats.default.percStr === 'NaN%' })
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  planOptions.default.map(function (e, i) {
                    return _react2.default.createElement(FundRowFull, {
                      key: 'fund-row-default-' + i,
                      investmentOption: e
                    });
                  })
                )
              ),
              _react2.default.createElement(TableDisclaimerFull, null)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'plan-option-card' },
              _react2.default.createElement(
                'h3',
                { styleName: 'table-strong' },
                'Equity funds'
              ),
              allocationStats.default.percStr === 'NaN%' ? null : _react2.default.createElement(
                'div',
                { styleName: 'doughnut-flex' },
                _react2.default.createElement(_reactChartjs.Doughnut, {
                  data: [{ value: allocationStats.equity.perc,
                    // label: 'Other',
                    color: '#313131' }, { value: allocationStats.equity.percOther,
                    // label: null,
                    color: '#D5D5D5' }],
                  options: _config2.default.chartOptions,
                  width: '150',
                  height: '150'
                }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'doughnut-flex-text' },
                  _react2.default.createElement(
                    'b',
                    null,
                    allocationStats.equity.count
                  ),
                  ' plan ',
                  _format2.default.maybePluralize(allocationStats.equity.count, 'option'),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'b',
                    null,
                    allocationStats.equity.percStr
                  ),
                  ' of plan assets'
                )
              ),
              _react2.default.createElement(
                'table',
                { styleName: 'full-row-table' },
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(FundRowFullHeader, { noAssets: allocationStats.default.percStr === 'NaN%' })
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  planOptions.equity.map(function (e, i) {
                    return _react2.default.createElement(FundRowFull, {
                      key: 'fund-row-equity-' + i,
                      investmentOption: e
                    });
                  })
                )
              ),
              _react2.default.createElement(TableDisclaimerFull, null)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'bond-other-cards-flex' },
              _react2.default.createElement(
                'div',
                { styleName: 'plan-option-card' },
                _react2.default.createElement(
                  'h3',
                  { styleName: 'table-strong' },
                  'Bond/fixed income funds'
                ),
                allocationStats.default.percStr === 'NaN%' ? null : _react2.default.createElement(
                  'div',
                  { styleName: 'doughnut-flex' },
                  _react2.default.createElement(_reactChartjs.Doughnut, {
                    data: [{ value: allocationStats.bond.perc,
                      // label: 'Bond funds',
                      color: '#313131' }, { value: allocationStats.bond.percOther,
                      // label: null,
                      color: '#D5D5D5' }],
                    options: _config2.default.chartOptions,
                    width: '150',
                    height: '150'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'doughnut-flex-text' },
                    _react2.default.createElement(
                      'b',
                      null,
                      allocationStats.bond.count
                    ),
                    ' plan ',
                    _format2.default.maybePluralize(allocationStats.bond.count, 'option'),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                      'b',
                      null,
                      allocationStats.bond.percStr
                    ),
                    ' of plan assets'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'table-disclaimer' },
                  'The results above do not include bond/fixed income funds and represent only the rated investment options (target date and equity funds). ',
                  _react2.default.createElement(
                    'b',
                    null,
                    'See our ',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        xstrong: true,
                        to: _config2.default.routes.fossilFuelBondsIn401ks,
                        title: 'Fossil fuel bonds in 401(k)s'
                      },
                      'new analysis'
                    ),
                    ' of fossil fuel bonds in 401(k)s for more information on bond funds.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'non-scored-funds-table-cell' },
                  _react2.default.createElement(FundRowHeader, { noAssets: allocationStats.default.percStr === 'NaN%' }),
                  planOptions.bond.map(function (e, i) {
                    return _react2.default.createElement(FundRowSlim, {
                      key: 'fund-row-bond-' + i,
                      investmentOption: e
                    });
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'plan-option-card' },
                _react2.default.createElement(
                  'h3',
                  { styleName: 'table-strong' },
                  'Other funds'
                ),
                allocationStats.default.percStr === 'NaN%' ? null : _react2.default.createElement(
                  'div',
                  { styleName: 'doughnut-flex' },
                  _react2.default.createElement(_reactChartjs.Doughnut, {
                    data: [{ value: allocationStats.other.perc,
                      // label: 'Other',
                      color: '#313131' }, { value: allocationStats.other.percOther,
                      // label: null,
                      color: '#D5D5D5' }],
                    options: _config2.default.chartOptions,
                    width: '150',
                    height: '150'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'doughnut-flex-text' },
                    _react2.default.createElement(
                      'b',
                      null,
                      allocationStats.other.count
                    ),
                    ' plan ',
                    _format2.default.maybePluralize(allocationStats.other.count, 'option'),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                      'b',
                      null,
                      allocationStats.other.percStr
                    ),
                    ' of plan assets'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'table-disclaimer' },
                  'We don\'t have ratings for some investment options like money market funds, stable value funds, company stock funds, seperately managed accounts, or anything invested via brokerage windows. The results above represent only the rated investment options (target date and equity funds). ',
                  _react2.default.createElement(
                    'b',
                    null,
                    'There may be additional unsustainable investments in these unrated investment options.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'non-scored-funds-table-cell' },
                  _react2.default.createElement(FundRowHeader, { noAssets: allocationStats.default.percStr === 'NaN%' }),
                  planOptions.other.map(function (e, i) {
                    return _react2.default.createElement(FundRowSlim, {
                      key: 'fund-row-other-' + i,
                      investmentOption: e
                    });
                  })
                )
              )
            )
          ) : null
        )
      );
    }
  }]);
  return PlanScorecardInvestmentOptions;
}(_react.Component), _class16.propTypes = {
  planId: _react.PropTypes.string,
  allocationStats: _react.PropTypes.object.isRequired,
  planOptions: _react.PropTypes.object.isRequired
}, _temp5)) || _class15);
exports.default = PlanScorecardInvestmentOptions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardInvestmentOptions/PlanScorecardInvestmentOptions.js
// module id = 1420
// module chunks = 0